import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'

export class NotificationService {
  static async successToast(message = '', isRtl = true) {
    Toastify({
      text: message,
      duration: 2000,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'center',
      stopOnFocus: true,
      style: {
        fontFamily: 'Fredoka',
        direction: `${isRtl ? 'rtl' : 'ltr'}`,
        background:
          'linear-gradient(to right, rgba(217, 115, 254, 1), rgba(74, 114, 255, 1))',
      },
    }).showToast()
  }
  static async errorToast(message = '', isRtl = true) {
    Toastify({
      text: message,
      duration: 2000,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'center',
      stopOnFocus: true,
      style: {
        fontFamily: 'Fredoka',
        direction: `${isRtl ? 'rtl' : 'ltr'}`,
        background:
          'linear-gradient(to right, rgba(255, 115, 115, 1), rgba(255, 74, 74, 1))',
      },
    }).showToast()
  }
}

export default {
  install(app) {
    app.config.globalProperties.$notify = NotificationService
  },
}
